import React, { FC, useState } from "react";
import { message } from "antd";
import ImportCaseStore from "../../../../contexts/importCaseStore";
import { downloadAllFiles, importFileUrl } from "../../../../services/importService";
import CollapseCard from "../../../../components/collapseCard";
import DocumentsUpload from "../../../../components/documentsUpload";
import _t from "../../../../lang/translate";
import { isAxiosError } from "../../../../utilities/typeGuard";

const ImportAttachmentsCard: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { importCase, setImportCase, isAdmin } = ImportCaseStore.useContainer();

  const handleDownloadAll = async () => {
    try {
      setLoading(true);
      const { data } = await downloadAllFiles(importCase.id);
      if (data?.url) window.open(data.url, "_blank");
    } catch (error) {
      const errorMessage = isAxiosError(error) ? error.response?.data?.message : null;
      message.error(errorMessage || _t("msg.unknown_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <CollapseCard title={_t("attachments")} loading={loading}>
      <DocumentsUpload
        onDownloadAll={handleDownloadAll}
        fileList={importCase.files || []}
        canLockFiles={isAdmin}
        onChange={({ fileList }) => {
          setImportCase({ ...importCase, files: fileList });
        }}
        action={importFileUrl(importCase?.id)}
      />
    </CollapseCard>
  );
};

export default ImportAttachmentsCard;
